import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal__overlay",
  tabindex: "-1",
  "data-micromodal-close": ""
}
const _hoisted_3 = ["aria-labelledby"]
const _hoisted_4 = { class: "modal__header" }
const _hoisted_5 = ["id"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "function-link modal__close",
  "aria-label": "Luk",
  "data-micromodal-close": ""
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon-svg",
    focusable: "false",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" })
  ]),
  /*#__PURE__*/_createTextVNode("Luk")
], -1)
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["for"]
const _hoisted_10 = ["id", "value"]
const _hoisted_11 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.modalId,
    "aria-hidden": "true",
    class: "modal"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        role: "dialog",
        class: "modal__container",
        "aria-modal": "true",
        "aria-labelledby": _ctx.modalId + '-title'
      }, [
        _createElementVNode("header", _hoisted_4, [
          _createElementVNode("h2", {
            class: "modal__title",
            id: _ctx.modalId + '-title'
          }, [
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.inviter-tilbudsgiver.overskrift' }, null, 8, ["tekstNoegle"])
          ], 8, _hoisted_5),
          _hoisted_6
        ]),
        _createElementVNode("main", {
          class: "modal__content",
          id: _ctx.modalId + '-content'
        }, [
          _createElementVNode("p", null, [
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.inviter-tilbudsgiver.beskrivelse' }, null, 8, ["tekstNoegle"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", {
              class: "form-label",
              for: 'copy-text-' + _ctx.modalId
            }, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.inviter-tilbudsgiver.kopier-link-til-tilbudsgiver' }, null, 8, ["tekstNoegle"])
            ], 8, _hoisted_9),
            _createElementVNode("input", {
              class: "form-input input-width-xl mt-3",
              id: 'copy-text-' + _ctx.modalId,
              value: _ctx.url,
              type: "text",
              readonly: ""
            }, null, 8, _hoisted_10)
          ])
        ], 8, _hoisted_7),
        _createElementVNode("footer", _hoisted_11, [
          _createElementVNode("button", {
            class: "button button-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args)))
          }, [
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.og-blanket.inviter-tilbudsgiver.kopier-link' }, null, 8, ["tekstNoegle"])
          ])
        ])
      ], 8, _hoisted_3)
    ])
  ], 8, _hoisted_1))
}